import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";


import AddressUpdateForm from "../../../../address/components/address/AddressForm/AddressUpdateForm";
import * as Address from "../../../../address/components/address/AddressForm/AddressUpdateForm";
import { t, msg } from "@lingui/core/macro"












export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        vatId: "",
        
    
        
        iban: "",
        
    
        
        bank: "",
        
    
        
        swift: "",
        
    
        addressIdAddress: Address.initialFormStateFn(),
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        vatId:
        string()
        .trim()
        .nullish(),
    
    
        iban:
        string()
        .trim()
        .nullish(),
    
    
        bank:
        string()
        .trim()
        .nullish(),
    
    
        swift:
        string()
        .trim()
        .nullish(),
    
    addressIdAddress: Address.formSchema,
    
};

export const formSchema = object(formObject);

const BuyerUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'vatId' }
       aria-label="vatId"
       data-testid="vatId"
       label={t`Vat Id`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'iban' }
       aria-label="iban"
       data-testid="iban"
       label={t`Iban`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'bank' }
       aria-label="bank"
       data-testid="bank"
       label={t`Bank`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'swift' }
       aria-label="swift"
       data-testid="swift"
       label={t`Swift`}
       
       type='text'
       
   />
   
   
            
            
   
   <Card>
       <CardHeader subheader={t`Address`}/>
       <CardContent><AddressUpdateForm prefix='addressIdAddress.'/></CardContent>
   </Card>
   
   
            
        </Container>
    )
}

export default BuyerUpdateForm;
